@if (!isMobile) {
    <div class="custom-toast-class" rtlDiv>
        <div class="dflex" rtlDiv>
            <div class="text-container">
                @if(data.action == 'delete'){
                    @if(currentLang != 'iw'){
                        <div class="text-container-delete" rtlDiv>
                            <div>{{ 'TITLES.PERFORMED' | translate }}&nbsp;</div>                            
                            <div class="bold-text">{{ 'TITLES.DELETED' | translate }}&nbsp;</div>
                            <div>{{data.events.length}} {{ 'TITLES.EVENTS' | translate }}</div>
                        </div>
                    }@else{
                        <div class="text-container-delete" rtlDiv>
                            <div>{{data.events.length}} {{ 'TITLES.EVENTS' | translate }}&nbsp;</div>
                            <div class="bold-text">{{ 'TITLES.DELETED' | translate }}&nbsp;</div>
                            <div>{{ 'TITLES.PERFORMED' | translate }}</div>
                        </div>
                    }
                }
                @if(data.action == 'accept'){
                    @if(currentLang != 'iw'){
                        <div class="text-container-delete" rtlDiv>
                            <div>{{ 'TITLES.PERFORMED' | translate }}&nbsp;</div>                            
                            <div class="bold-text">{{ 'TITLES.ACCEPTED' | translate }}&nbsp;</div>
                            <div>{{data.events.length}} {{ 'TITLES.EVENTS' | translate }}</div>
                        </div>
                    }@else{
                        <div class="text-container-delete" rtlDiv>
                            <div>{{data.events.length}} {{ 'TITLES.EVENTS' | translate }}&nbsp;</div>
                            <div class="bold-text">{{ 'TITLES.ACCEPTED' | translate }}&nbsp;</div>
                            <div>{{ 'TITLES.PERFORMED' | translate }}</div>
                        </div>
                    }
                }
            </div>
            <div class="undo-container">
                <div class="undo-text" (click)="undo()">{{ 'TITLES.UNDO' | translate }}</div>
                <img class="divider-vertical" src="assets/images/reports/divider.svg">
                <div class="close-btn" rtlDiv (click)="closeSnackbar()">
                    <img class="close-img" src="assets/images/reports/white_close.svg">
                </div>
            </div>
        </div>
    </div>

}

@if (isMobile) {}